import { HttpErrorResponse } from '@angular/common/http';
import { APP_INITIALIZER, Provider } from '@angular/core';
import { AuthErrorFilter } from '@abp/ng.core';
import { OAuthErrorFilterService } from '@abp/ng.oauth';
import { OAuthErrorEvent } from 'angular-oauth2-oidc';

/**
 * Segunda linha de defesa do refresh resiliente (a primeira e o
 * RefreshTokenResilienceInterceptor).
 *
 * O ABP, em todo OAuthErrorEvent, chama clearOAuthStorage() para apagar a
 * sessao, A MENOS que OAuthErrorFilterService.run(event) retorne true (caminho 3
 * descrito no interceptor). O run() retorna true se ALGUM filtro `executable`
 * registrado retornar true no execute(event).
 *
 * Aqui registramos um filtro que manda PULAR o clearOAuthStorage quando o
 * `token_refresh_error` foi causado por falha de transporte (sem resposta /
 * 5xx) e nao por um erro definitivo (invalid_grant 400). Se o interceptor ja
 * tiver absorvido o blip, esse evento nem chega; isso aqui cobre o caso de o
 * erro de transporte escapar do interceptor.
 *
 * Importante (trade-off): isto so neutraliza o caminho 3. Em queda sustentada
 * o ABP ainda desloga pelos caminhos 1 (navigateToLogin) e 2
 * (refreshToken().catch -> clearOAuthStorage), que nao sao filtraveis.
 */
const refreshTransportErrorFilter: AuthErrorFilter<OAuthErrorEvent> = {
  id: 'refresh-token-transport-error',
  executable: true,
  execute: (event: OAuthErrorEvent): boolean => {
    if (event?.type !== 'token_refresh_error') {
      return false;
    }
    const reason = event.reason as HttpErrorResponse | undefined;
    const status = reason?.status;
    return status === 0 || (typeof status === 'number' && status >= 500);
  },
};

export const REFRESH_TOKEN_ERROR_FILTER_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: (oAuthErrorFilter: OAuthErrorFilterService) => () => {
    oAuthErrorFilter.add(refreshTransportErrorFilter);
  },
  deps: [OAuthErrorFilterService],
};
